import React from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { appInsights } from '../../../auth/appInsight';
import { useMediaQuery, useTheme } from '@mui/material';
import { getStringProduct } from '../../../utils/utilityFunctions';
import useBreakPoints from '../../../CustomHooks/useBreakPoints';

const FreedomScrollBar = ({ vh, height = '100%', width = '100%', children, containerRef }) => {
  const theme = useTheme();
  const {getAdjustedValues} = useBreakPoints();
  try {
    return (
      <PerfectScrollbar
        containerRef={containerRef}
        style={{
          height: vh ? vh : `${getAdjustedValues(height)}`,
          width:`${getAdjustedValues(width)}`
          // paddingRight: '10px'
        }}
      >
        {children}
      </PerfectScrollbar>
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default FreedomScrollBar;
